export default () => ({
  popularCoursesFetchStatus: null,
  latestCoursesFetchStatus: null,
  latestCourses: [],
  popularCourses: []
})
